export default __webpack_public_path__ + "static/googleplay-51a1f923e7adaa24bba568d007122ad4.png";